/* eslint-disable @typescript-eslint/naming-convention */

import {PlayerColor} from '@colonist/game-states'
import {ImageURL, LobbyImage} from '@colonist/types'
import {getLobbyImagePath} from '../ui_utils/Utils.ts'
import PlayerHighlightLeft from '@static/images/player_highlight_left.svg'
import PlayerHighlightRight from '@static/images/player_highlight_right.svg'
import {Sprites as SpritesImported} from './UIGameSprites.ts'

enum Tag {
    // Images for Preloading
    Universal,
    SpriteSheet,
    Sprite,
}

export interface ImageInterface {
    name: string
    path: ImageURL
    tags: Tag[]
}

export import Sprites = SpritesImported

const allImages: ImageInterface[] = [
    {name: 'ranking_divisions/bronze', path: getLobbyImagePath(LobbyImage.RankBronze), tags: [Tag.Universal]},
    {name: 'ranking_divisions/gold', path: getLobbyImagePath(LobbyImage.RankGold), tags: [Tag.Universal]},
    {name: 'ranking_divisions/grandmaster', path: getLobbyImagePath(LobbyImage.RankGrandmaster), tags: [Tag.Universal]},
    {name: 'ranking_divisions/diamond', path: getLobbyImagePath(LobbyImage.RankDiamond), tags: [Tag.Universal]},
    {name: 'ranking_divisions/master', path: getLobbyImagePath(LobbyImage.RankMaster), tags: [Tag.Universal]},
    {name: 'ranking_divisions/platinum', path: getLobbyImagePath(LobbyImage.RankPlatinum), tags: [Tag.Universal]},
    {name: 'ranking_divisions/silver', path: getLobbyImagePath(LobbyImage.RankSilver), tags: [Tag.Universal]},

    {name: 'ranking_divisions/subdivisions_i', path: getLobbyImagePath(LobbyImage.RankSubdivisionI), tags: [Tag.Universal]},
    {name: 'ranking_divisions/subdivisions_ii', path: getLobbyImagePath(LobbyImage.RankSubdivisionII), tags: [Tag.Universal]},
    {name: 'ranking_divisions/subdivisions_iii', path: getLobbyImagePath(LobbyImage.RankSubdivisionIII), tags: [Tag.Universal]},
    {name: 'ranking_divisions/subdivisions_iv', path: getLobbyImagePath(LobbyImage.RankSubdivisionIV), tags: [Tag.Universal]},

    // @ts-expect-error import.meta not allowed in cjs
    {name: 'game_spritesheet_wait_icon', path: new URL('@static/images/game_spritesheet_wait_icon.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    // @ts-expect-error import.meta not allowed in cjs
    {name: 'game_spritesheet_wait_icon_mobile', path: new URL('@static/images/game_spritesheet_wait_icon_mobile.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},

    // @ts-expect-error import.meta not allowed in cjs
    {name: 'game_spritesheet_0', path: new URL('@static/images/game_spritesheet_0.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    // @ts-expect-error import.meta not allowed in cjs
    {name: 'game_spritesheet_1', path: new URL('@static/images/game_spritesheet_1.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    // @ts-expect-error import.meta not allowed in cjs
    {name: 'game_spritesheet_2', path: new URL('@static/images/game_spritesheet_2.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    // @ts-expect-error import.meta not allowed in cjs
    {name: 'game_spritesheet_3', path: new URL('@static/images/game_spritesheet_3.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    // @ts-expect-error import.meta not allowed in cjs
    {name: 'game_spritesheet_4', path: new URL('@static/images/game_spritesheet_4.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    // @ts-expect-error import.meta not allowed in cjs
    {name: 'game_spritesheet_5', path: new URL('@static/images/game_spritesheet_5.json', import.meta.url).toString() as ImageURL, tags: [Tag.Universal, Tag.SpriteSheet]},
    {name: 'player_highlight_left', path: PlayerHighlightLeft, tags: [Tag.Universal, Tag.Universal]},
    {name: 'player_highlight_right', path: PlayerHighlightRight, tags: [Tag.Universal, Tag.Universal]},

    // Uncomment if spritesheets are needed
    // {name: 'game_spritesheet_6', path: new URL('@static/images/game_spritesheet_6.json', import.meta.url).toString(), tags: [Tag.Universal, Tag.SpriteSheet]},
    // {name: 'game_spritesheet_7', path: new URL('@static/images/game_spritesheet_7.json', import.meta.url).toString(), tags: [Tag.Universal, Tag.SpriteSheet]},
    // {name: 'game_spritesheet_8', path: new URL('@static/images/game_spritesheet_8.json', import.meta.url).toString(), tags: [Tag.Universal, Tag.SpriteSheet]},
    // {name: 'game_spritesheet_9', path: new URL('@static/images/game_spritesheet_9.json', import.meta.url).toString(), tags: [Tag.Universal, Tag.SpriteSheet]},
]

export function getImagesToPreload(): ImageInterface[] {
    return allImages.filter((img: ImageInterface) => img.tags.includes(Tag.Universal))
}

export function getImageNameFromFileName(fileName: string): string | undefined {
    const searchString = `/${fileName}`
    const image = allImages.find((img: ImageInterface) => img.path.includes(searchString))
    return image?.name
}

export function getMerchantImageNameForPlayer(player: PlayerColor): string {
    switch(player) {
        case PlayerColor.None: return ''
        case PlayerColor.Red: return 'icon_merchant_red'
        case PlayerColor.Blue: return 'icon_merchant_blue'
        case PlayerColor.Orange: return 'icon_merchant_orange'
        case PlayerColor.Green: return 'icon_merchant_green'
        case PlayerColor.Black: return 'icon_merchant_black'
        case PlayerColor.Bronze: return 'icon_merchant_bronze'
        case PlayerColor.Silver: return 'icon_merchant_silver'
        case PlayerColor.Gold: return 'icon_merchant_gold'
        case PlayerColor.White: return 'icon_merchant_white'
        case PlayerColor.Purple: return 'icon_merchant_purple'
        case PlayerColor.MysticBlue: return 'icon_merchant_mysticblue'
        case PlayerColor.Pink: return 'icon_merchant_pink'
    }
}
